import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export class ApiError extends Error {
  constructor(status, detail) {
    super(typeof detail === 'string' ? detail : detail?.message || 'Request failed');
    this.status = status;
    this.detail = detail;
  }
}

const authHeaders = () => {
  const token = localStorage.getItem('session_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Officials API helper. orgId is sent as ?org_id and (for JSON bodies) body.org_id.
export async function oapi(path, { method = 'GET', body, orgId, query } = {}) {
  const params = new URLSearchParams();
  Object.entries(query || {}).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') params.set(k, v); });
  if (orgId) params.set('org_id', orgId);
  const qs = params.toString() ? `?${params}` : '';
  const isForm = body instanceof FormData;
  if (isForm && orgId) body.append('org_id', orgId);
  const payload = isForm ? body : body !== undefined ? JSON.stringify(orgId ? { ...body, org_id: orgId } : body) : undefined;
  const res = await fetch(`${API_URL}/api${path}${qs}`, {
    method,
    headers: { ...authHeaders(), ...(isForm || payload === undefined ? {} : { 'Content-Type': 'application/json' }) },
    body: payload,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new ApiError(res.status, data.detail);
  return data;
}

export async function odownload(path, query, filename) {
  const params = new URLSearchParams(Object.entries(query || {}).filter(([, v]) => v !== undefined && v !== null && v !== ''));
  const res = await fetch(`${API_URL}/api${path}?${params}`, { headers: authHeaders() });
  if (!res.ok) throw new ApiError(res.status, 'Download failed');
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export const fileUrl = (p) => (p ? `${API_URL}/api/files/${p}` : null);

export function fmtGameDate(date) {
  if (!date) return 'Date TBD';
  const [y, m, d] = date.slice(0, 10).split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
}

export function fmtGameTime(time) {
  const m = /^(\d{1,2}):(\d{2})/.exec(time || '');
  if (!m) return 'Time TBD';
  const h = Number(m[1]);
  return `${((h + 11) % 12) + 1}:${m[2]} ${h >= 12 ? 'PM' : 'AM'}`;
}

export const fmtWhen = (g) => `${fmtGameDate(g?.date)} · ${fmtGameTime(g?.time)}`;

export const splitList = (v) => String(v || '').split(/[;,|]/).map(s => s.trim()).filter(Boolean);

export const uid = () => Math.random().toString(36).slice(2, 12);

export const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

export async function uploadOfficialPhoto(file) {
  const fd = new FormData();
  fd.append('file', file);
  const res = await fetch(`${API_URL}/api/upload/headshot`, { method: 'POST', headers: authHeaders(), body: fd });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new ApiError(res.status, data.detail || 'Upload failed');
  return data.storage_path;
}

export async function copyText(text, label = 'Link') {
  try {
    await navigator.clipboard.writeText(text);
    toast.success(`${label} copied`);
  } catch {
    window.prompt('Copy this:', text);
  }
}

export function addonIsActive(user) {
  const a = user?.officials_addon;
  return !!a && ['active', 'cancelled'].includes(a.status) && !!a.expires_at && new Date(a.expires_at) > new Date();
}

export const fmtMoney = (minor, currency = 'USD') => {
  try { return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format((minor || 0) / 100); }
  catch { return `${((minor || 0) / 100).toFixed(2)} ${currency}`; }
};

export const minorToInput = (minor) => (minor === null || minor === undefined ? '' : (minor / 100).toFixed(2));

export const newKey = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${uid()}${uid()}`);

export const todayYmd = () => ymd(new Date());
